let examEls = document.querySelectorAll(".exams");

// if the course plans are not loaded yet, wait a bit and try again
if (examEls.length > 0) {
    loadExams(examEls);
} else {
    setTimeout(() => {
        examEls = document.querySelectorAll(".exams");
        if (examEls.length > 0) {
            loadExams(examEls);
        } else {
            setTimeout(() => {
                examEls = document.querySelectorAll(".exams");
                loadExams(examEls);
                if (examEls.length === 0) {
                    console.warn("Couldn't find exam elements.");
                }
            }, 400);
        }
    }, 100);
}

function loadExams(examEls) {
    examEls.forEach((exams) => {
        // INFORMATION RETRIEVAL

        let holidays;
        try {
            if (exams.dataset.holidays) {
                holidays = JSON.parse(exams.dataset.holidays);
            }
        } catch (e) {
            console.error(e);
        }

        const fixedHolidays = ["01-01", "01-06", "05-01", "08-15", "10-26", "11-01", "12-08", "12-25", "12-26"];

        const headlineEls = exams.querySelectorAll(".exams h3");
        const preExamEls = exams.querySelectorAll(".exams__day--pre-exam");
        const examPreparationEls = exams.querySelectorAll(".exams__day--exam-preparation");
        const computerExamEls = exams.querySelectorAll(".exams__day--computer-exam");
        const drivingExamEls = exams.querySelectorAll(".exams__day--driving-exam");

        if (window.matchMedia("(max-width: 767px)").matches) {
            headlineEls.forEach((el) => {
                el.classList.remove("exams__headline--shown");
            });
        }

        const today = new Date();
        fillPreExams();
        fillExamPreparations();
        fillComputerExams();
        fillDrivingExams();

        headlineEls.forEach((el) => {
            el.addEventListener("click", () => {
                el.classList.toggle("exams__headline--shown");
            });
        });

        function generateContent(date, time) {
            return `<b>${date.toLocaleDateString("de-DE", {
                weekday: "short",
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            })}</b> ${time}`;
        }

        function fillPreExams() {
            const time = "09:00 - 17:00 Uhr";
            const nextDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);
            nextDate.setDate(today.getDate() + ((3 + 7 - today.getDay()) % 7));

            // check if nextDate is in the 2 week rhythm
            const startDate = new Date(2023, 8, 27);
            if (getDateDiff(startDate, nextDate) % 14 !== 0) {
                nextDate.setDate(nextDate.getDate() + 7);
            }

            preExamEls.forEach((el, index) => {
                const date = new Date(nextDate);
                date.setDate(date.getDate() + index * 2 * 7);
                const examPreparationDate = new Date(date);
                examPreparationDate.setDate(examPreparationDate.getDate() + 1);

                if (noExamToday(date)) {
                    return;
                }

                if (isHoliday(date)) {
                    date.setDate(date.getDate() - 1);
                }

                if (isHoliday(examPreparationDate)) {
                    date.setDate(date.getDate() - 1);
                }

                el.innerHTML = generateContent(date, time);
            });
        }

        function fillExamPreparations() {
            const time = "18:00 Uhr";
            const nextDate = new Date();
            nextDate.setDate(today.getDate() + ((4 + 7 - today.getDay()) % 7));

            examPreparationEls.forEach((el, index) => {
                const date = new Date(nextDate);
                date.setDate(date.getDate() + index * 7);

                if (noExamToday(date)) {
                    return;
                }

                if (isHoliday(date)) {
                    date.setDate(date.getDate() - 1);
                }

                el.innerHTML = generateContent(date, time);
            });
        }

        function fillComputerExams() {
            const time = "13:00 Uhr";
            const nextDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);
            nextDate.setDate(today.getDate() + ((4 + 7 - today.getDay()) % 7));

            // check if nextDate is in the 2 week rhythm
            const startDate = new Date(2023, 8, 28);
            if (getDateDiff(startDate, nextDate) % 14 !== 0) {
                nextDate.setDate(nextDate.getDate() + 7);
            }

            computerExamEls.forEach((el, index) => {
                const date = new Date(nextDate);
                date.setDate(date.getDate() + index * 2 * 7);

                if (noExamToday(date)) {
                    return;
                }

                if (isHoliday(date)) {
                    date.setDate(date.getDate() - 1);
                }

                el.innerHTML = generateContent(date, time);
            });
        }

        function fillDrivingExams() {
            const time = "ab 08:00 Uhr";
            const nextDate = new Date();
            nextDate.setDate(today.getDate() + ((5 + 7 - today.getDay()) % 7));

            let amountOfHolidays = 0;
            drivingExamEls.forEach((el, index) => {
                const date = new Date(nextDate);
                date.setDate(date.getDate() + (index + amountOfHolidays) * 7);

                if (noExamToday(date)) {
                    return;
                }

                if (isHoliday(date)) {
                    amountOfHolidays++;
                    date.setDate(date.getDate() + 7);
                }

                el.innerHTML = generateContent(date, time);
            });
        }

        function isHoliday(date) {
            const dateInHolidayFormat = toISODateString(date).substring(5);

            return holidays.includes(toISODateString(date)) || fixedHolidays.includes(dateInHolidayFormat);
        }

        function noExamToday(date) {
            const christmas =
                date.getMonth() === 0 ? new Date(date.getFullYear() - 1, 11, 24) : new Date(date.getFullYear(), 11, 24); // 24.12.
            const holyThreeKings =
                date.getMonth() === 0 ? new Date(date.getFullYear(), 0, 7) : new Date(date.getFullYear() + 1, 0, 7); // 6.1. but we need to add 1 day for boundary

            return date.getTime() > christmas.getTime() && date.getTime() < holyThreeKings.getTime();
        }

        function toISODateString(date) {
            return `${date.getFullYear()}-${(date.getMonth() + 1)
                .toString()
                .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
        }

        function getDateDiff(firstDate, secondDate) {
            if (firstDate > secondDate) {
                return Math.round((firstDate - secondDate) / (1000 * 60 * 60 * 24));
            } else {
                return Math.round((secondDate - firstDate) / (1000 * 60 * 60 * 24));
            }
        }
    });
}
